import { computed, DOCUMENT, effect, inject, Injectable, signal } from '@angular/core';
import { ThemeType } from '@core/theme/theme-type.enum';

@Injectable({ providedIn: 'root' })
export class ThemeService {
  readonly #document = inject(DOCUMENT);
  readonly #THEME_KEY = 'theme';

  readonly #themeState = signal<ThemeType>(this.#getInitialTheme());

  readonly currentTheme = computed(() => this.#themeState());
  readonly isDark = computed(() => this.currentTheme() === ThemeType.DARK);

  constructor() {
    this.#themeChangeEffect();
  }

  toggleTheme(): void {
    this.#themeState.set(this.isDark() ? ThemeType.LIGHT : ThemeType.DARK);
  }

  #getInitialTheme(): ThemeType {
    const saved = localStorage.getItem(this.#THEME_KEY) as ThemeType | null;
    if (saved === ThemeType.DARK || saved === ThemeType.LIGHT) {
      return saved;
    }

    return ThemeType.LIGHT;
  }

  #themeChangeEffect(): void {
    effect(() => {
      const theme = this.currentTheme();

      this.#document.documentElement.setAttribute('data-theme', theme === ThemeType.DARK ? theme : ThemeType.LIGHT);

      localStorage.setItem(this.#THEME_KEY, theme);
    });
  }
}
